import { createFileRoute } from '@tanstack/react-router';
import { ChainAnnouncementDetailPage } from '@/pages/chain/ChainAnnouncementDetailPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/chain/announcements/$announcementId')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['chainContent.read'], redirectTo: '/dashboard' }),
	component: ChainAnnouncementDetailPage,
});
